const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="3.429"
      d="M21.074.502.502 21.074a1.714 1.714 0 0 0 0 2.424 1.714 1.714 0 0 0 2.424 0L23.498 2.926a1.714 1.714 0 0 0 0-2.424 1.714 1.714 0 0 0-2.424 0"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="3.429"
      d="M1.714 0A1.71 1.71 0 0 0 .502.502a1.714 1.714 0 0 0 0 2.424l20.572 20.572a1.714 1.714 0 0 0 2.424 0 1.714 1.714 0 0 0 0-2.424L2.926.502A1.71 1.71 0 0 0 1.714 0"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
